import { render } from "./PrescriberChat.vue?vue&type=template&id=05244900"
import script from "./PrescriberChat.vue?vue&type=script&lang=js"
export * from "./PrescriberChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__